<template>
  <div class="credit">
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import SiruiTable from '@/components/SiruiTable';

  export default {
    components: {
      SiruiTable,
    },
    name: 'orderLadingLimitCurrencyList',
    data() {
      return {
        load: false,
        img: '/static/img/tips.png',
        query: {
          businessDepartment: '', //事业部门
          partnerType: '', //合作伙伴类型
          onlyShow: '', //只显示母公司额度
          partner: '', //业务合作伙伴
          creditCode: '', //信用账户号
        },
        customerNo: '',
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        partnerTypeList: [], //企业类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        creditTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
      };
    },
    computed: {
      //表格显示字段
      columnList() {
        return [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          { field: 'controlareaCode', title: '控制范围编码', visible: true },
          { field: 'controlareaName', title: '控制范围描述', visible: true },
          { field: 'partnerType', title: '合作伙伴类型', visible: true },
          { field: 'partnerNo', title: '合作伙伴编码', visible: true },
          { field: 'partnerName', title: '合作伙伴名称', visible: true },
          { field: 'currencyName', title: '币种', visible: true },
          { field: 'receiveAmount', title: '收款（原币）', visible: true },
          { field: 'refundAmount', title: '退款（原币）', visible: true },
          { field: 'ladingAmount', title: '发货金额（原币）', visible: true },
          { field: 'salesReturnAmount', title: '销售金额（原币）', visible: true },
          { field: 'balanceAmount', title: '客户余额（原币）（收-发）', visible: true },
          { field: 'companyBalanceAmount', title: '客户余额（人民币）（收-发）', visible: true },
        ];
      },
      ...mapState({
        creditInfo: (state) => state.creditInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
    },
    methods: {
      //获取数据
      getData() {
        this.load = true;
        this.$axios.get(API.ORDER_APPLICATION_STATISTICS_API + this.$route.query.id).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //搜索
      detailBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'edit') {
          if (JSON.stringify(this.multipleSelection) == '{}') {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.noSelectEdit'),
              type: 'error',
            });
          } else {
            let path = {
              title: '',
              path: 'creditAdd',
              name: '',
              query: { id: 1 },
            };
            this.$store.commit('LIST_ADD_TABS', path);
          }
        }
      },
      //新增
      add() {
        let path = {
          title: '',
          path: 'creditAdd',
          name: '',
          query: { id: 1 },
        };
        this.$store.commit('LIST_ADD_TABS', path);
      },
      //删除
      del() {
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            //TODO调用接口
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            //如果有错误返回，提示信息
            this.$alert(this.$t('applicationCredit.msg.errText'));
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //双击事件
      dblclickEvent(e) {
        let path = {
          path: '/credit/orderLadingLimitDetail',
          name: 'orderLadingLimitDetail',
          meta: {
            keepAlive: true,
            title: '委托加工入库单详情',
          },
          query: {
            id: e.row.id,
            isEdit: 'Y',
          },
        };
        console.log(e.row.id);
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
